<p class="description">{{ 'components.offlineDialog.labels.description' | translate }}</p>
